import { render, staticRenderFns } from "./DepositModal.vue?vue&type=template&id=36abb8f1&scoped=true"
import script from "./DepositModal.vue?vue&type=script&lang=js"
export * from "./DepositModal.vue?vue&type=script&lang=js"
import style0 from "./DepositModal.vue?vue&type=style&index=0&id=36abb8f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36abb8f1",
  null
  
)

export default component.exports